import { UserCompanyRole } from "../access-management/user-company-role.model";

export class User {

    constructor(public email: string = null, public applicationRole: number = null, public firstName: string = null, public lastName: string = null, public applicationRoleName: string = null, public status: string) {

    }
}

export class UserWithComanyRoles extends User {
    userCompanyRoles: UserCompanyRole[];
    constructor(email: string = null, applicationRole: number = null, firstName: string = null, lastName: string = null, applicationRoleName: string = null, status: string = null) {

        super(email, applicationRole, firstName, lastName, applicationRoleName, status);
        this.userCompanyRoles = [];
    }
}